/**
 * @file     systemCopy.ts
 * @purpose  MessageRef catalog for system-level UI labels: common actions (subscribe, submit, go home, request consultation, open video).
 */
import { messageRef } from '../messageRef';

export const systemCopy = {
  actions: {
    subscribe: messageRef('common.actions.subscribe'),
    submitting: messageRef('common.actions.submitting'),
    goHome: messageRef('common.actions.goHome'),
    requestConsultation: messageRef('common.actions.requestConsultation'),
    openVideo: messageRef('common.actions.openVideo'),
  },
} as const;
